;

(function ($) {
  "use strict";

  $(document).ready(function ($) {
    $('.woocommerce-account .u-column2 h2').on('click', function () {
      $('.woocommerce-form-register').slideToggle();
    });
  });
})(jQuery);
;

(function ($) {
  "use strict";

  $(document).ready(function ($) {
    /**
     * Close side cart
     */
    $('.side-cart__close').on('click', function (e) {
      e.preventDefault();
      $('.side-cart').removeClass('side-cart--open');
    });
    /**
     * Open side cart
     */

    $('.header-cart').on('click', function (e) {
      if (!$(this).hasClass('header-cart--checkout')) {
        e.preventDefault();
        $('.side-cart').toggleClass('side-cart--open');
      }
    });
    /**
     * Coupon slide toggle
     */

    $('.page-inner').on('click', '.coupon-top', function (e) {
      e.preventDefault();
      $(this).next().slideToggle();
    });
    /**
     * Open side cart when product added
     */

    $(document.body).on('added_to_cart', function (e, data) {
      console.log('CartData', data);
      $('.side-cart').addClass('side-cart--open'); // update top label
    });
    /**
     * Update header icon count
     */

    $(document.body).on('wc_fragments_loaded', function (e) {
      const currentCount = $('.sela-cart__top .cart-title').data('count');
      $('.header-cart__count').html(currentCount);
    });
  });
  /**
   * Cart content in checkout page on mobile
   */
})(jQuery);

function showCartContent(el) {
  if (jQuery(window).width() > 991) return;
  if (!jQuery(el).closest('.sela-cart').length) return;
  jQuery('.sela-cart .sela-cart__top').toggleClass('sela-cart__top--open');
  jQuery('.sela-cart .woocommerce-mini-cart').slideToggle();
}
;

(function ($) {
  "use strict";

  let firstTime = true;
  $(document).ready(function ($) {
    const classes = ['.col2-set', '#order_review_heading', '.woocommerce-checkout-review-order-table', '.woocommerce-checkout-payment', '.checkout-shipping-btns'];
    $('.sela-checkout').on('click', '.to-customer-details', function (e) {
      e.preventDefault();
      handleClasses(e, '.col2-set', '.sela-customer-datails');
    });
    $('.sela-checkout').on('click', '.to-shipping', function (e) {
      e.preventDefault();

      if (!$(this).hasClass('checkout-back')) {
        vlidateFirstStep();
      } else {
        handleClasses(e, '#order_review_heading, .woocommerce-checkout-review-order-table, .checkout-shipping-btns', '.sela-shipping-method', true);
      }

      function vlidateFirstStep() {
        $('form.checkout .woocommerce-error').remove();
        addFormLoader();
        const url = window.location.origin + '?wc-ajax=checkout_validation';
        $.ajax({
          type: 'POST',
          url: url,
          data: $('form.checkout').serialize(),
          dataType: 'json'
        }).done(function (data) {
          if (data.result === "failure" && data.messages) {
            $('form.checkout').prepend(data.messages);
          } else {
            handleClasses(e, '#order_review_heading, .woocommerce-checkout-review-order-table, .checkout-shipping-btns', '.sela-shipping-method', true);
          }

          $('.lds-dual-ring').remove();
        });
      }
    });

    function handleClasses(e, selector, tabSelector, isShipping = false) {
      e.preventDefault();
      $(classes.join(', ')).css('display', 'none');
      $(selector + ':first').css('display', 'block');
      $('.sela-checkout-top li').removeClass('active');
      $(tabSelector).addClass('active');
      $('.woocommerce-checkout-review-order').removeClass('show-shipping');

      if (isShipping) {
        $('.woocommerce-checkout-review-order').addClass('show-shipping');
      }
      /**
       * Handle shipping button
       */


      handleShippingButns();
    }

    function handleShippingButns() {
      const oldElement = document.querySelector(".checkout-shipping-btns");
      const newElement = oldElement.cloneNode(true);
      oldElement.parentNode.replaceChild(newElement, oldElement);
      $('.to-payment').on('click', function (e) {
        e.preventDefault();
        handleClasses(e, '.woocommerce-checkout-payment', '.sela-payment');
      });
    }
  });

  try {
    /**
     * wc_checkout_params not always exists, therefore try is needed
     */
    if (wc_checkout_params) {
      if (wc_checkout_params.is_checkout === '1') {
        $('.to-shipping').on('click', function (e) {// const $body = jQuery('body')
          // $body.trigger('update_checkout');
          // $body.trigger('update_cart');
        });
      }
    }
  } catch (e) {} // $( document.body ).trigger( 'updated_shipping_method' );

  /**
   * Needed to prevent tab navigation bug
   */


  const $checkoutForm = $('form.woocommerce-checkout');
  const $problematicSpan = $('.woocommerce form .form-row .optional');
  $('body').on('updated_checkout', function (e, data) {
    // $checkoutForm.css('visibility', 'visible')
    // $problematicSpan.css('visibility', 'visible')
    console.log('Data', data);
    $('.lds-dual-ring').remove();
    $('.sela-cart__sum').append(data.fragments['.woocommerce-checkout-review-order-table']);
    $('.sela-cart__sum #shipping_method input:not([checked="checked"])').parent('li').remove();
    $('.sela-cart__sum #shipping_method input').remove();
    $('.sela-cart__sum #shipping_method label').removeAttr('for');
  });
  $('body').on('update_checkout', function () {
    $('.sela-cart__sum *').remove();
    $('.sela-cart__sum').append('<div class="lds-dual-ring lds-dual-ring--small"></div>');
    if (!firstTime) return;
    firstTime = false;
    addFormLoader();
  });

  function addFormLoader() {
    const loaderHtml = '<div class="lds-dual-ring"></div>';

    if (!document.querySelector('.lds-dual-ring')) {
      $('form.woocommerce-checkout').append(loaderHtml);
    }
  }
})(jQuery);
;

(function ($) {
  "use strict";

  $(document).ready(function ($) {
    $('.mobile-filter-icon').on('click', function () {
      $('.cat-sidebar').addClass('cat-sidebar--active');
    });
    $('.cat-sidebar__close').on('click', function () {
      $('.cat-sidebar').removeClass('cat-sidebar--active');
    });
    jQuery(document).on("woof_ajax_done", woof_ajax_done_handler);

    function woof_ajax_done_handler(e) {
      $('.cat-sidebar').removeClass('cat-sidebar--active');
      $('html, body').animate({
        scrollTop: $("#woof_results_by_ajax").offset().top - 140
      }, 500);
    }
  });
})(jQuery);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    $('#btnControl').on('change', function () {
      $('.mobile-menu').toggleClass('mobile-menu--open');

      if ($('.sela-search').hasClass('appear')) {
        $('.sela-search').toggleClass('appear disappear');
      }
    });
    const $topLevelItem = $('.mobile-menu .menu-primary-container > .menu > .menu-item-has-children > a');
    const $secondLevelItem = $('.mobile-menu .menu-primary-container > .menu > .menu-item-has-children > a ~ .sub-menu > .menu-item-has-children > a');
    $topLevelItem.on('click', function (e) {
      e.preventDefault();
      $(this).siblings('.sub-menu').slideToggle(400, 'linear');
    });
    $secondLevelItem.on('click', function (e) {
      e.preventDefault();
      $(this).next().slideToggle(400, 'linear');
    });
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    // const $modal_member = $('.modal--member');
    let videoId = ''; //
    // // 	Occurs when the modal is about to be shown
    // $modal_member.on('  &:hover {\n' +
    //     '    background-image: linear-gradient(to left, lighten($color-gradiant-start, 10%), lighten($color-gradiant-end, 10%));\n' +
    //     '  }', function(){
    //     const id = $(this).attr('id');
    //     const $toggle = $(`[href="#${id}"]`);
    //     $toggle.addClass('js-open')
    // });
    //
    //
    // // Occurs when the modal is about to be hidden
    // $modal_member.on('hide.bs.modal', function(){
    //     const id = $(this).attr('id');
    //     const $toggle = $(`[href="#${id}"]`);
    //     $toggle.removeClass('js-open')
    // });

    $('.open-modal').on('click', function (e) {
      e.preventDefault();
      videoId = this.dataset.videoId;

      if (videoId) {
        $('.modal').addClass('modal-yt');
      }

      $('.modal').modal('show');
    });
    $(".modal").on('show.bs.modal', function () {
      // inject id
      if (videoId) {
        const iframe = this.querySelector('iframe');
        iframe.src = `https://www.youtube.com/embed/${videoId}/?autoplay=1`;
      }
    });
    $(".modal").on('hide.bs.modal', function () {//  $('.modal').removeClass('modal-yt')
    });
    $(".modal").on('hidden.bs.modal', function () {
      const iframe = this.querySelector('iframe');
      iframe.src = ``;
      $('.modal').removeClass('modal-yt');
    });
    $('.close').on('click', function () {
      $('.modal').modal('hide');
    });
  });
})(window, document, jQuery);
;

(function ($) {
  "use strict";

  $(document).ready(function ($) {
    /**
     * Tabs
     */
    $('.product-accordion__title').on('click', function (e) {
      e.preventDefault();
      this.classList.toggle('product-accordion__title--active');
      $(this).next().slideToggle();
    });
    /**
     * Quantity
     *
     * Affecting on the cart as well
     */

    $('.page-inner').on('click', '.quantity__add', function (e) {
      const $qtyInput = $(this).parent().find('.qty');
      const initialValue = parseInt($qtyInput.val());
      $qtyInput.val(initialValue + 1);
    });
    $('.page-inner').on('click', '.quantity__sub', function (e) {
      const $qtyInput = $(this).parent().find('.qty');
      const initialValue = parseInt($qtyInput.val());
      initialValue > 1 && $qtyInput.val(initialValue - 1);
    });
  });
})(jQuery);
;

(function ($) {
  "use strict";

  $(document).ready(function ($) {
    const $searchWrapper = $('.sela-search');
    let open = false;
    const isMobile = $(window).width() <= 991;
    $('.search-icon').on('click', function () {
      $('.mobile-menu').removeClass('mobile-menu--open');
      $('#btnControl').prop('checked', false);

      if ($searchWrapper.hasClass('appear') || $searchWrapper.hasClass('disappear')) {
        $searchWrapper.toggleClass('appear disappear');
      } else {
        $searchWrapper.addClass('appear');
      }

      open = !open;

      if (open) {
        $('.aws-search-field').focus();
        isMobile && $('body').addClass('no-scroll');
      } else {
        isMobile && $('body').removeClass('no-scroll');
      }
    });
    $(document).on('click', '.sela-search__close', function () {
      $searchWrapper.toggleClass('appear disappear');
      open = false;
      isMobile && $('body').removeClass('no-scroll');
      $('.mobile-menu').removeClass('mobile-menu--open');
    });
  });
})(jQuery);
;

(function (window, document, $) {
  "use strict";

  jQuery(document).ready(function ($) {
    const iconsSlider = new Swiper('.icons-slider__slider', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      slidesPerView: 3,
      breakpoints: {
        1200: {
          slidesPerView: 6
        }
      },
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
    const sliders = document.querySelectorAll('.slider');
    sliders.forEach(el => {
      new Swiper(el, {
        slidesPerView: $(window).innerWidth() >= 767 ? 5 : 3,
        spaceBetween: 0,
        loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });
    });
  });
})(window, document, jQuery);